document.addEventListener('click', function(event) {
    if (event.target.matches('.edit_link')) {
      document.querySelectorAll('.donebox').forEach(donebox => {
        //donebox.hidden = true;
      });
      document.querySelectorAll('.content').forEach(content => {
        content.hidden = true;
      });
      const currentStep = event.target.closest('.steps');
      if (currentStep) {
        const currentContent = currentStep.querySelector('.content');
        const currentDonebox = currentStep.querySelector('.donebox');
        if (currentContent) {
            currentContent.hidden = false;
        }
        if (currentDonebox) {
            currentDonebox.hidden = true;
        }
      }
    }
  });
  document.querySelector('#step1 .button').addEventListener('click', function() {
    const anbieterError = document.querySelector('.anbieter_error');
    const anbieterErrorSpan = document.querySelector('.anbieter_error--text');
    const anbieterSelect =document.querySelectorAll('.anbieter-card input[type="radio"]');
    const anbiterIsSelected = Array.from(anbieterSelect).some(input => input.checked);
    
    if (!anbiterIsSelected) {
      anbieterErrorSpan.textContent = "Bitte wähle einen Leasinganbieter aus";
      anbieterError.hidden = false
      return;
    }
    const content = document.querySelector('#step1 .content');
    if (content) {
        content.hidden = true;
    }
    const donebox = document.querySelector('#step1 .donebox');
    if (donebox) {
        donebox.hidden = false;
    }
    
    const step2Donebox = document.querySelector('#step2 .donebox');
    if (step2Donebox) {
        step2Donebox.hidden = true;
    }
    
    const step2 = document.querySelector('#step2');
    if (step2) {
        step2.classList.remove("steps--disbaled");
    }
    const step2Content = document.querySelector('#step2 .content');
    if (step2Content) {
        step2Content.hidden = false
    }
  });
  document.querySelector('#step2 .button').addEventListener('click', function() {
    const kundeVornameSpan = document.querySelector('.kunde_vorname');
    const kundeNachnameSpan = document.querySelector('.kunde_nachname');
    const kundeStrasseSpan = document.querySelector('.kunde_strasse');
    const kundeHausnummerSpan = document.querySelector('.kunde_hausnummer');
    const kundeLandSpan = document.querySelector('.kunde_land');
    const kundePlzSpan = document.querySelector('.kunde_plz');
    const kundeOrtSpan = document.querySelector('.kunde_ort');
    const kundeEmailSpan = document.querySelector('.kunde_email');
    const kundeTelefonSpan = document.querySelector('.kunde_telefon');
    const adressError = document.querySelector('.adress_error');
    const adressErrorSpan = document.querySelector('.adress_error--text');
    const vorname = document.querySelector("#leasingForm input[name='Vorname']").value;
    const nachname = document.querySelector("#leasingForm input[name='Nachname']").value;
    const strasse = document.querySelector("#leasingForm input[name='Strasse']").value;
    const hausnummer = document.querySelector("#leasingForm input[name='Hausnummer']").value;
    const land = document.querySelector("#leasingForm select[name='Land']").value;
    const plz = document.querySelector("#leasingForm input[name='PLZ']").value;
    const ort = document.querySelector("#leasingForm input[name='Ort']").value;
    const email = document.querySelector("#leasingForm input[name='Email']").value;
    const telefon = document.querySelector("#leasingForm input[name='Telefon']").value;
    const fehlendeFelder = [];
    if (!vorname) fehlendeFelder.push("Vorname");
    if (!nachname) fehlendeFelder.push("Nachname");
    if (!strasse) fehlendeFelder.push("Straße");
    if (!hausnummer) fehlendeFelder.push("Hausnummer");
    if (!land) fehlendeFelder.push("Land");
    if (!plz) fehlendeFelder.push("PLZ");
    if (!ort) fehlendeFelder.push("Ort");
    if (!email) fehlendeFelder.push("E-Mail");
    if (!telefon) fehlendeFelder.push("Telefonnummer");
    if (fehlendeFelder.length > 0) {
      adressErrorSpan.textContent = "Bitte füllen Sie folgende Felder aus: " + fehlendeFelder.join(", ");
      adressError.hidden = false
      return;
    }
    adressError.hidden = true
    adressErrorSpan.textContent = "";
    kundeVornameSpan.textContent = vorname;
    kundeNachnameSpan.textContent = nachname;
    kundeStrasseSpan.textContent = strasse;
    kundeHausnummerSpan.textContent = hausnummer;
    kundeLandSpan.textContent = land;
    kundePlzSpan.textContent = plz;
    kundeOrtSpan.textContent = ort;
    kundeEmailSpan.textContent = "E-Mail: " + email;
    kundeTelefonSpan.textContent = telefon ? "Telefon: " + telefon : "";
    
    const content = document.querySelector('#step2 .content');
    if (content) {
        content.hidden = true;
    }
    const donebox = document.querySelector('#step2 .donebox');
    if (donebox) {
        donebox.hidden = false;
    }
    const step3 = document.querySelector('#step3');
    if (step3) {
        step3.classList.remove("steps--disbaled");
    }
    const step3Content = document.querySelector('#step3 .content');
    if (step3Content) {
        step3Content.hidden = false
    }
    const step3Donebox = document.querySelector('#step3 .donebox');
    if (step3Donebox) {
        step3Donebox.hidden = true;
    }
  });
    
  document.querySelector('#step3 .button').addEventListener('click', function() {
    const versand_StrasseSpan = document.querySelector('.versand_strasse');
    const versand_HausnummerSpan = document.querySelector('.versand_hausnummer');
    const versand_PlzSpan = document.querySelector('.versand_plz');
    const versand_OrtSpan = document.querySelector('.versand_ort');
    const versand_shippingSpan = document.querySelector('.versand_shipping');
    const versand_strasse = document.querySelector("#leasingForm input[name='Versand_Strasse']").value;
    const versand_hausnummer = document.querySelector("#leasingForm input[name='Versand_Hausnummer']").value;
    const versand_plz = document.querySelector("#leasingForm input[name='Versand_PLZ']").value;
    const versand_ort = document.querySelector("#leasingForm input[name='Versand_Ort']").value;
    const versand_shipping = document.querySelector("#leasingForm select[name='Shipping']").value;
    const versand_checkbox = document.querySelector("#leasingForm input[name='data-shipping-address-checkbox']");
    const versand_adressError = document.querySelector('.adress_error--versand');
    const versand_adressErrorSpan = document.querySelector('.adress_error--versand--text');
    
    const versand_fehlendeFelder = [];
    if (!versand_strasse) versand_fehlendeFelder.push("Straße");
    if (!versand_hausnummer) versand_fehlendeFelder.push("Hausnummer");
    if (!versand_plz) versand_fehlendeFelder.push("PLZ");
    if (!versand_ort) versand_fehlendeFelder.push("Ort");
    if (versand_checkbox.checked && versand_fehlendeFelder.length > 0) {
      versand_adressErrorSpan.textContent = "Bitte füllen Sie folgende Felder aus: " + versand_fehlendeFelder.join(", ");
      versand_adressError.hidden = false
      return;
    }
    if (!versand_shipping) {
      versand_adressErrorSpan.textContent = "Bitte wählen Sie eine Versand oder Abholoption";
      versand_adressError.hidden = false
      return;
    }
    
    versand_shippingSpan.textContent = versand_shipping;
    
    if (versand_shipping === "Versand") {
      versand_adressError.hidden = true;
      versand_adressErrorSpan.textContent = "";
      versand_shippingSpan.textContent = "Versand"
      versand_StrasseSpan.textContent = versand_strasse;
      versand_HausnummerSpan.textContent = versand_hausnummer;
      versand_PlzSpan.textContent = versand_plz;
      versand_OrtSpan.textContent = versand_ort;
    }else{
      versand_StrasseSpan.textContent = "";
      versand_HausnummerSpan.textContent = "";
      versand_PlzSpan.textContent = "";
      versand_OrtSpan.textContent = "";
      document.querySelector("#leasingForm input[name='Versand_Strasse']").value = "";
      document.querySelector("#leasingForm input[name='Versand_Hausnummer']").value = "";
      document.querySelector("#leasingForm input[name='Versand_PLZ']").value = "";
      document.querySelector("#leasingForm input[name='Versand_Ort']").value = "";
    }
    
    const content = document.querySelector('#step3 .content');
    if (content) {
        content.hidden = true;
    }
    const donebox = document.querySelector('#step3 .donebox');
    if (donebox) {
        donebox.hidden = false;
    }
    
    const step4 = document.querySelector('#step4');
    if (step4) {
        step4.classList.remove("steps--disbaled");
    }
    const step4Content = document.querySelector('#step4 .content');
    if (step4Content) {
        step4Content.hidden = false
    }
  });
    
  document.addEventListener('DOMContentLoaded', () => {
    const radioInputs = document.querySelectorAll('.anbieter-card input[type="radio"]');
    const quickfactBox = document.querySelector('.infobox');
    const quickfactBoxText = document.querySelector('.infobox--text');
    const anbieterDoneName = document.querySelector('.anbieter_done_name');
    const anbieterDoneInfo = document.querySelector('.anbieter_done_info');
    const anbieterLogo = document.querySelector('.donebox img');
    const leasingPartnerData = document.querySelectorAll('.leasing-partner-data');
    radioInputs.forEach(input => {
      input.addEventListener('change', () => {
        leasingPartnerData.forEach(function(el) {
           el.hidden = true;
        });
        const quickfact = input.getAttribute('data-quickfact');
        const name = input.getAttribute('data-name');
        const info = input.getAttribute('data-info');
        const logo = input.getAttribute('data-image');
        const value = input.value;
        const anbieterError = document.querySelector('.anbieter_error');
        const anbieterErrorSpan = document.querySelector('.anbieter_error--text');
        anbieterError.hidden = true
        anbieterErrorSpan.textContent = "";  
        const partnerAngaben = document.querySelector(`[id="leasing-partner-${value}"]`);
        if (partnerAngaben){
          partnerAngaben.hidden = false;
        }
        
        anbieterLogo.src = logo;
        anbieterDoneName.textContent = name;
        anbieterDoneInfo.textContent = info;      
        quickfactBoxText.innerHTML = quickfact;
        quickfactBox.hidden = false;
      });
    });
  });
  const addressCheckbox = document.querySelector('input[name="data-shipping-address-checkbox"]');
  const addressSelectField = document.querySelector('select[name="Shipping"]');
  const versandAddressElements = document.querySelectorAll('.versand_address');
  addressSelectField.addEventListener('change', function () {
      if (addressSelectField.value === "Versand") {
        addressCheckbox.parentElement.hidden = false;
      } else {
        addressCheckbox.checked = false;
        addressCheckbox.parentElement.hidden = true;      
        versandAddressElements.forEach(element => element.setAttribute('hidden', ''))
      }
  });
  addressCheckbox.addEventListener('change', function () {
      if (addressCheckbox.checked) {
          versandAddressElements.forEach(element => element.removeAttribute('hidden'));
      } else {
          versandAddressElements.forEach(element => element.setAttribute('hidden', ''));
      }
  });
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("form").forEach(form => {
      form.addEventListener("submit", function (event) {
        let submitButton = event.submitter;
        if (!submitButton || !submitButton.classList.contains("button--outline")) {
          return;
        }
        if (!form.checkValidity()) {
          return;
        }
        event.preventDefault();
        let message = document.createElement("div");
        message.className = "cart-success-message";
        message.innerText = "Das Zubehör wurde hinzugefügt.";
        form.appendChild(message);
        setTimeout(() => {
          message.remove();
        }, 3000);
      });
    });
  });